<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>违规预警</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="发送人" prop="adminid">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入管理员名称搜索"
              v-model="search.adminid"
              :query-request="getBasicPlatformUsersIndex"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="el-icon-refresh-left"
                     @click="onReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">违规预警</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="{name: '违规类型管理'}">
          <el-button size="small" icon="el-icon-setting">维护违规类型</el-button>
        </router-link>
        <router-link :to="{name: '添加违规预警消息'}">
          <el-button type="primary"
                     size="small"
                     icon="sj-icon-add">添加预警消息
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <el-table-column prop="id" label="id" width="80"></el-table-column>
        <el-table-column label="接收人" min-width="120">
          <template slot-scope="scope">
            违规名单 {{ scope.row.receiver_count || 0 }} 人
          </template>
        </el-table-column>
        <el-table-column label="违规类型" min-width="140">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.violation_type_name" type="danger" size="mini">{{ scope.row.violation_type_name }}</el-tag>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="sender_name" label="发送人" width="120"></el-table-column>
        <el-table-column prop="created_at" label="发送时间" min-width="160"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <router-link :to="{name: '违规预警发送名单', params: {id: scope.row.id}}">
              <el-button type="text" size="small">查看名单</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'

export default {
  mixins: [table],
  data () {
    return {
      search: {
        adminid: null,
      },
      searchFieldType: {
        current_page: Number,
        per_page: Number,
        adminid: Number,
      },
    }
  },
  methods: {
    ...request.map(['getBasicPlatformUsersIndex', 'getPlatformUsersDetail']),
    getTableData (params) {
      return request.page('violationAlertRecordQuery', params)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/violation-alert/pages/ViolationAlertTable.vue